/* Core & libraries */
import React from 'react';
import { useTheme } from "react-jss";
import Image from "react-bootstrap/Image";

/* Helpers, constants, custom methods, internal libraries */
import { useUserContext } from "../../contexts/userContext";
import { useIsMobile } from "../../hooks/useIsMobile";
import { ReactComponent as LogoAASvg } from '../../resources/images/aa-logo.svg';
import { ReactComponent as LogoAAMobileSvg } from '../../resources/images/aa-logo-mobile.svg';
import { ReactComponent as LogoDashSvg } from '../../resources/images/dash-logo.svg';
import { ReactComponent as LogoUCMobileSvg } from '../../resources/images/uc-logo-mobile.svg';
import { ReactComponent as LogoASSvg } from '../../resources/images/as-logo.svg';
import { ReactComponent as LogoASMobileSvg } from '../../resources/images/as-logo-mobile.svg';
import { ReactComponent as LogoCHOICESvg } from '../../resources/images/choice-logo-large.svg';
import { ReactComponent as LogoAMSvg } from '../../resources/images/am-logo-large.svg';
import { ReactComponent as LogoAMMobileSvg } from '../../resources/images/am-logo-mobile.svg';
import { ReactComponent as LogoACSvg } from '../../resources/images/ac-logo-large.svg';
import { ReactComponent as LogoACMobileSvg } from '../../resources/images/ac-logo-mobile.svg';
import { ReactComponent as LogoCHOICEMobileSvg } from '../../resources/images/landing-choice-logo-small.svg';
import { AIRLINES, DASH_CLIENT_LOGO_URL, DASH_CLIENT_MOBILE_LOGO_URL } from '../../constants/appConstants';

/* Components */
/* Styles */
import styles from "./styles";

const LogoSwitcher = ({ className }) => {

  const theme = useTheme();
  const classes = styles({ theme });
  const userContext = useUserContext();
  const isMobile = useIsMobile();

  const brandingID = userContext?.userInfo?.companyInfo?.brandingId;
  const baseUrl = `${window.location.protocol}//${window.location.host}`;
  const clientLogoPath = DASH_CLIENT_LOGO_URL;
  const clientMobileLogoPath = DASH_CLIENT_MOBILE_LOGO_URL;
  const ucClientLogo = `${baseUrl}${clientLogoPath?.replace("{brandingID}", brandingID?.toLowerCase())}`;
  const ucClientMobileLogo = `${baseUrl}${clientMobileLogoPath?.replace("{brandingID}", brandingID?.toLowerCase())}`;

  const providerCode = userContext?.userInfo?.providerInfo?.providerCode;

  const getAirlineLogo = () => {
    switch(providerCode) {
      case AIRLINES.AA:
        return isMobile ? <LogoAAMobileSvg /> : <LogoAASvg />;
      case AIRLINES.UC:
        if (brandingID) {
          return isMobile 
            ? <Image src={ucClientMobileLogo} /> 
            : <Image src={ucClientLogo} />;
        } else {
          return <LogoDashSvg />;
        }
      case AIRLINES.AS:
        return isMobile ? <LogoASMobileSvg /> : <LogoASSvg />;
      case AIRLINES.CHOICE:
        return <LogoCHOICESvg />;
      case AIRLINES.AM:
        return isMobile ? <LogoAMSvg /> : <LogoAMSvg />;
      case AIRLINES.AC:
        return isMobile ? <LogoACMobileSvg /> : <LogoACSvg />;
      default:
        return null;
    }
  }

  // Add a helper to pick the override class for AA or AS
  const getProviderOverrideClass = () => {
    if (providerCode === AIRLINES.AA) return classes.AA;
    if (providerCode === AIRLINES.AS) return classes.AS;
    if (providerCode === AIRLINES.CHOICE) return classes.CHOICE;
    if (providerCode === AIRLINES.AC) return classes.AC;
    // UC or others rely on default style (32px height)
    return '';
  }

  return (
    <div className={`${classes.logo} ${getProviderOverrideClass()}${className ? ` ${className}` : ''}`}>
      { getAirlineLogo() }
    </div>
  );
};

export default LogoSwitcher;